import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Stack,
  Text,
} from "@chakra-ui/react";
import { loadDataFromElement } from "../utils/hydrate-data";

const oauthApplicationName = loadDataFromElement<string>(
  "oauth-application-name",
  "",
);

export function AuthorizationSuccessView() {
  return (
    <Alert
      status="success"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      height="200px"
    >
      <AlertIcon boxSize="40px" mr={0} />
      <AlertTitle mt={4} mb={1} fontSize="lg">
        Authorization successful
      </AlertTitle>
      <AlertDescription maxWidth="sm">
        <Stack spacing={2} paddingTop={4}>
          <Text>
            You successfully authorized <b>{oauthApplicationName}</b>.
          </Text>
          <Text>You may now close this window.</Text>
        </Stack>
      </AlertDescription>
    </Alert>
  );
}
